export default "__VITE_ASSET__DKxzC47X__"